export default __webpack_public_path__ + "static/media/swap-icon.c2898851.svg";